"use strict";

document.getElementsByTagName('body')[0].classList.add('animated');

function parallaxElements() {
  var width = window.innerWidth;
  var scrolled = window.pageYOffset;
  var elements = document.querySelectorAll('.js-parallax');

  for (var i = 0; i < elements.length; i += 1) {
    if (width > 767) {
      var coef = parseFloat(elements[i].getAttribute('data-coef'));
      elements[i].style.transform = "translateY(".concat(coef * scrolled, "px)");
      elements[i].style.webkitTransform = "translateY(".concat(coef * scrolled, "px)");
    } else {
      elements[i].style.transform = 'translateY(0)';
      elements[i].style.webkitTransform = 'translateY(0)';
    }
  }
}

window.addEventListener('load', parallaxElements);
window.addEventListener('scroll', parallaxElements);
window.addEventListener('resize', parallaxElements);

function loadNews() {
  var httpRequest = new XMLHttpRequest();

  httpRequest.onreadystatechange = function () {
    if (this.readyState == 4 && this.status == 200) {
      var response = JSON.parse(this.responseText);
      console.log(response);
      var aside = document.createElement('aside');
      aside.className = 'news';
      var asideTitle = document.createElement('strong');
      asideTitle.className = 'news__title';
      asideTitle.innerHTML = response.title;
      var asideLink = document.createElement('a');
      asideLink.className = 'news__link';
      asideLink.href = response.url;
      asideLink.target = '_blank';
      asideLink.innerHTML = response.label;
      aside.appendChild(asideTitle);
      aside.appendChild(asideLink);
      var header = document.getElementById('header'); // Get the <ul> element to insert a new node

      header.parentNode.insertBefore(aside, header);
    }
  };

  httpRequest.open('GET', 'https://www.candycane.coffee/wp-json/onesip/v1/news');
  httpRequest.send();
}

function findUpTag(el, attr) {
  while (el.parentNode) {
    el = el.parentNode;

    if (el[attr]) {
      return el;
    }
  }

  return null;
}

loadNews();

window.onload = function () {
  var easeInCubic = function easeInCubic(t) {
    return t * t * t;
  };

  var scrollElems = document.getElementsByClassName('js-scroll');

  var scrollToElem = function scrollToElem(start, stamp, duration, scrollEndElemTop, startScrollOffset) {
    var runtime = stamp - start;
    var progress = runtime / duration;
    var ease = easeInCubic(progress);
    window.scroll(0, startScrollOffset + scrollEndElemTop * ease);

    if (runtime < duration) {
      requestAnimationFrame(function () {
        var newstamp = new Date().getTime();
        scrollToElem(start, newstamp, duration, scrollEndElemTop, startScrollOffset);
      });
    }
  };

  for (var i = 0; i < scrollElems.length; i += 1) {
    var elem = scrollElems[i];
    elem.addEventListener('click', function (e) {
      e.preventDefault();
      var href = e.target.href;

      if (!href) {
        var closest = findUpTag(e.target, 'href');

        if (closest) {
          href = closest.href;
        }
      }

      var scrollElemId = href.split('#')[1];
      var scrollEndElem = document.getElementById(scrollElemId); // eslint-disable-next-line no-unused-vars

      var anim = requestAnimationFrame(function () {
        var newstamp = new Date().getTime();
        var duration = 1200;
        var start = newstamp;
        var startScrollOffset = window.pageYOffset;
        var scrollEndElemTop = scrollEndElem.getBoundingClientRect().top;
        scrollToElem(start, newstamp, duration, scrollEndElemTop, startScrollOffset);
      });
    });
  }
};
/* eslint-disable no-unused-vars */


var mapItems = [{
  position: {
    lat: 50.091279,
    lng: 14.425394
  },
  url: 'images/marker.png'
}];
var mapStyle = [{
  featureType: 'all',
  elementType: 'labels.text.fill',
  stylers: [{
    saturation: 36
  }, {
    color: '#333333'
  }, {
    lightness: 40
  }]
}, {
  featureType: 'all',
  elementType: 'labels.text.stroke',
  stylers: [{
    visibility: 'on'
  }, {
    color: '#ffffff'
  }, {
    lightness: 16
  }]
}, {
  featureType: 'all',
  elementType: 'labels.icon',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'administrative',
  elementType: 'geometry.fill',
  stylers: [{
    color: '#fefefe'
  }, {
    lightness: 20
  }]
}, {
  featureType: 'administrative',
  elementType: 'geometry.stroke',
  stylers: [{
    color: '#fefefe'
  }, {
    lightness: 17
  }, {
    weight: 1.2
  }]
}, {
  featureType: 'landscape',
  elementType: 'geometry',
  stylers: [{
    color: '#ade0b2'
  }]
}, {
  featureType: 'poi',
  elementType: 'geometry',
  stylers: [{
    color: '#f5f5f5'
  }, {
    lightness: 21
  }]
}, {
  featureType: 'poi.park',
  elementType: 'geometry',
  stylers: [{
    color: '#dedede'
  }, {
    lightness: 21
  }]
}, {
  featureType: 'road.highway',
  elementType: 'geometry.fill',
  stylers: [{
    color: '#ffffff'
  }, {
    lightness: 17
  }]
}, {
  featureType: 'road.highway',
  elementType: 'geometry.stroke',
  stylers: [{
    color: '#ffffff'
  }, {
    lightness: 29
  }, {
    weight: 0.2
  }]
}, {
  featureType: 'road.arterial',
  elementType: 'geometry',
  stylers: [{
    color: '#ffffff'
  }, {
    lightness: 18
  }]
}, {
  featureType: 'road.local',
  elementType: 'geometry',
  stylers: [{
    color: '#ffffff'
  }, {
    lightness: 16
  }]
}, {
  featureType: 'transit',
  elementType: 'geometry',
  stylers: [{
    color: '#f2f2f2'
  }, {
    lightness: 19
  }]
}, {
  featureType: 'water',
  elementType: 'geometry',
  stylers: [{
    color: '#ffffff'
  }, {
    lightness: 17
  }]
}];

function initMap() {
  var bounds = new google.maps.LatLngBounds();
  var el = document.getElementById('map');
  var map = new google.maps.Map(el, {
    disableDefaultUI: true,
    zoom: 12,
    styles: mapStyle
  });

  for (var i = 0; i < mapItems.length; i++) {
    var item = mapItems[i];
    var icon = {
      url: item.url,
      size: new google.maps.Size(60, 60),
      scaledSize: new google.maps.Size(60, 60)
    };
    var marker = new google.maps.Marker({
      icon: icon,
      map: map,
      position: item.position
    });
    bounds.extend(marker.getPosition());
  }

  map.fitBounds(bounds, {
    top: 50,
    right: 50,
    bottom: 50,
    left: 50
  });
}
/* eslint-enable */
//# sourceMappingURL=main.js.map
